import { render, staticRenderFns } from "./UpEstablishment.vue?vue&type=template&id=c06657ea&scoped=true&slot-scope=scope&"
import script from "./UpEstablishment.vue?vue&type=script&lang=js&"
export * from "./UpEstablishment.vue?vue&type=script&lang=js&"
import style0 from "./UpEstablishment.vue?vue&type=style&index=0&id=c06657ea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06657ea",
  null
  
)

export default component.exports